import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PolizaMgavilan2025Fw = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251015-Poliza-de-Servicios_Firewall.pdf`;
  /*const pdfUrl = "/pdf/251015-Poliza-de-Servicios_Firewall.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza 2025 Firewall</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Póliza 2025 Firewall" />
      </Container>
    </>
  );
};

 export default PolizaMgavilan2025Fw;
